"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _react2 = require("@emotion/react");

var _reakit = require("reakit");

var _preset = _interopRequireDefault(require("../../themes/preset"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  theme: (0, _propTypes.shape)({}),
  children: _propTypes.node.isRequired
};
var defaultProps = {
  theme: _preset["default"]
};

var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react2.ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reakit.Provider, {
      children: children
    })
  });
};

ThemeProvider.propTypes = propTypes;
ThemeProvider.defaultProps = defaultProps;
var _default = ThemeProvider;
exports["default"] = _default;

//# sourceMappingURL=ThemeProvider.js.map